import { render, staticRenderFns } from "./CeoAbroadInvest.vue?vue&type=template&id=731c442a"
import script from "./CeoAbroadInvest.vue?vue&type=script&lang=js"
export * from "./CeoAbroadInvest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports